module.exports = __webpack_public_path__ + "img/6.27beb813.jpg";